import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BankStatementRuleJointTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.joint.type.enum';
import { BankStatementRuleJointTypeEnumI18n } from '@zaoblako/shared/modules/document/i18n/bank.statement.rule.joint.type.enum.i18n';

@Pipe({
  name: 'bankStatementRuleJointTypeName',
  standalone: true
})
export class BankStatementRuleJointTypeNamePipe implements PipeTransform {
  public transform(type: BankStatementRuleJointTypeEnum): string {
    return BankStatementRuleJointTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
